import { render } from "./IconWork.vue?vue&type=template&id=57e9ab74"
import script from "./IconWork.vue?vue&type=script&lang=js"
export * from "./IconWork.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__